/* eslint-disable no-console */
import axios, { AxiosInstance } from 'axios'
import applyCaseMiddleware from 'axios-case-converter'
import camelcaseKeys from 'camelcase-keys'
import { localStorageWorkspaceId } from '.'
import { handleTokenExpire } from '../session'
import { createFlashMessage } from './createFlashMessage'

export const getAxios = (baseUrl?: string, header?: string, formData?: boolean) : AxiosInstance => {
  const testMode = process.env.NX_ENV !== 'PROD'
  const axiosInstance = applyCaseMiddleware(axios.create(
    {
      baseURL: baseUrl,
    },
  ))
  axiosInstance.defaults.headers.common.Authorization = header || ''
  const workspaceId = localStorage?.getItem(localStorageWorkspaceId)
  if (formData && workspaceId) {
    axiosInstance.defaults.headers = {
      'Content-Type': 'multipart/form-data',
      Authorization: header || '',
      'Workspace-Id': workspaceId,
    }
  }

  if (workspaceId) {
    axiosInstance.defaults.headers = {
      ...axiosInstance.defaults.headers,
      'Workspace-Id': workspaceId,
    }
  }

  let body: {
    // eslint-disable-next-line camelcase
    catchment_id?: string
  }

  // usable for debugging
  axiosInstance.interceptors.request.use(
    (value) => {
      body = value.data
      if (testMode) {
        console.log('\n')
        console.log('getAxios request ↓')
        console.dir(value)
        console.log('getAxios caller ↓ ')
        console.trace()
        console.log('\n')
      }
      return value
    },
  )

  axiosInstance.interceptors.response.use(
    (response) => camelcaseKeys(response, {
      deep: true,
    }),
    (error) => {
      if (testMode) {
        console.log('getAxios error ↓')
        console.dir(error)
      }
      if (error.response.status === 504 && (baseUrl?.includes('data') || baseUrl?.includes('bigben'))) {
        window?.localStorage.setItem('timeoutModal', body.catchment_id || '')
        window?.dispatchEvent(new CustomEvent('timeoutModal'))
      }

      if (error?.response?.data?.message === 'status.error.generic.invalid_token_provided' || error?.response?.data?.status === 'status.error.generic.invalid_token_provided') {
        handleTokenExpire()
      }

      createFlashMessage({
        message: error?.response?.data?.status || error?.response?.data?.message || 'status.info.generic.something_went_wrong',
      })

      Promise.reject(error?.response?.data || 'status.info.generic.something_went_wrong')
    },
  )

  return axiosInstance
}

